<template>
    <div>
        <p class="block text-sm text-gray-900 mb-1" v-if="label">{{
            label
        }}</p>
        <!-- <Multiselect
            :mode="mode"
            :searchable="searchable"
            :placeholder="placeholder"
            :disabled="disabled"
            :options="options"
            :close-on-select="closeOnSelect"
            v-model="value"
            class="frm-multiselect"
        /> -->
        <Multiselect
            :mode="mode"
            :searchable="searchable"
            :placeholder="placeholder"
            :disabled="disabled"
            :options="options"
            v-model="value"
            @change="$emit('change')"
            @select="$emit('select')"
            @clear="$emit('clear')"
            class="frm-multiselect"
            :id="id"
            :name="name"
        />
        <p
            v-if="error"
            class="text-[10px] mt-1"
            :class="error ? 'text-red-600' : 'text-gray-800'"
            id="email-error"
        >
            {{ error }}
        </p>
    </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import Multiselect from '@vueform/multiselect';

const props = defineProps({
    modelValue: {
        default: null,
        required: true
    },
    mode: {
        type: String,
        default: 'single' // single | multiple | tags
    },
    error: {
        type: String,
        default: null,
    },
    searchable: {
        type: Boolean,
        default: false
    },
    id: {
        type: String,
    },
    name: {
        type: String,
    },
    label: {
        type: String,
    },
    placeholder: {
        type: String,
        default: 'Placeholder'
    },
    disabled: {
        type: Boolean,
        default: false
    },
    closeOnSelect: {
        type: Boolean,
        default: true
    },
    options: {
        type: Object,
        default: () => ({
            1: 'Option 1',
            2: 'Option 2',
            3: 'Option 3'
        })
    }
});

const emit = defineEmits<{
    ( e: 'update:modelValue', val: object): void
}>()

const value = computed<object>({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', value);
    }
})
</script>